import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { ClientService } from 'src/app/services/client.service';
import { ContextService } from 'src/app/services/context.service';
import { DropboxService } from 'src/app/services/dropbox.service';

@Component({
	selector: 'app-message',
	templateUrl: './message.component.html',
	styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {
	@Output() emitRequestCancelled = new EventEmitter<any>();
	@Input() signatureObject: any;
	@Input() expanded: boolean;
	@Input() readonly: boolean;

	loading = false;
	loadingDownload = false;
	//loadingSendReminder = false;
	//loadingContinueRequest = false;

	existingSignatories;

	// signature: any;
	// participants: any;

	showReminders = false;
	reminderMessage = '';
	reminders = [];

	cancelMessage = '';
	showCancelButton = false;

	constructor(
		private clientService: ClientService,
		public contextService: ContextService,
		private dropboxService: DropboxService,
		private router: Router,
	) { }

	ngOnInit() {
		console.log('signatureObject');
		console.log(this.signatureObject);
		// Set if its expired
		// if (this.signature.signatureExpirationDate) {
		// 	const expirationDate = new Date(this.signature.signatureExpirationDate);
		// 	if (new Date() > expirationDate) {
		// 		this.signatureRequestExpired = true;
		// 	}
		// }

		if (this.signatureObject.clientSignature.status === 'REQUESTED') {
			this.getReminders();
		}
	}

	cancelAndResend() {
		// this.loading = true;
		// const requestBody = this.form.getRawValue();
		// requestBody['signatureRequestId'] = this.signature.signatureRequestId;
		// requestBody['user_name'] = this.contextService.procoreUserInfo ? this.contextService.procoreUserInfo.email : '';

		// this.dropboxService.cancelRequest(requestBody, this.contextService.procoreIsSandbox).subscribe((result: any) => {
		// 	this.submit();
		// });
	}


	cancelRequest() {
		this.loading = true;
		this.dropboxService.cancelRequest(this.signatureObject.clientSignature.signatureRequestId, this.contextService.procoreUserInfo.email, this.contextService.procoreContextObject.context.company_id, this.contextService.procoreIsSandbox).subscribe((response) => {
			this.emitRequestCancelled.emit(this.signatureObject);
			this.loading = false;
		}, (err) => {
			if ((this.signatureObject.clientSignature.requestedUser == this.contextService.procoreUserInfo.email) || this.contextService.clientDetailProcore.anyUserCanCancel) {
				this.cancelMessage = 'An error occurred while cancelling the request. If you are sure this request does not exist in Dropbox Sign, you can mark it as cancelled:';
				this.showCancelButton = true;
			} else {
				this.cancelMessage = 'An error occurred while cancelling the request.';
				this.showCancelButton = false;
			}
			this.loading = false;
		});
	}

	getReminders() {
		this.dropboxService.getReminders(this.contextService.procoreContextObject.context.company_id, this.signatureObject.clientSignature.signatureRequestId).subscribe((result: any[]) => {
			this.reminders = result;
		});
	}

	sendReminder() {
		this.loading = true;
		let signerEmail = '';
		for (const signer of this.signatureObject.signatures) { // undefined
			if (signer.status_code === 'awaiting_signature') {
				signerEmail = signer.signer_email_address;
				break;
			}
		}

		if (signerEmail) {
			this.dropboxService.sendReminder(this.contextService.procoreContextObject.context.company_id, this.signatureObject.clientSignature.signatureRequestId, signerEmail, this.contextService.procoreUserInfo?.email).subscribe((result: any) => {
				this.reminderMessage = result.reminderMessage;
				this.reminders = result.reminders;
				this.loading = false;
			}, (err) => {
				if (err.status === 400) {
					this.reminderMessage = 'You do not have permission to send a reminder for this request.';
				} else {
					this.cancelMessage = 'An error occurred while sending a reminder.';
				}
				this.loading = false;
			});
		} else {
			this.loading = false;
		}
	}

	downloadRequest() {
		this.loadingDownload = true;
		this.dropboxService.getSignatureDownloadStream(this.contextService.procoreContextObject.context.company_id, this.signatureObject.clientSignature.signatureRequestId, this.signatureObject.clientSignature.filename, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
			.subscribe((result) => {
				saveAs(result, this.signatureObject.clientSignature.filename);
				this.loadingDownload = false;
			});
	}

	viewRequest() {
		this.loading = true;
		// this.adobeService.getAdobeAuthoringAgreement(this.signatureObject.clientSignature.signatureRequestId, this.contextService.procoreContextObject.context.company_id, this.contextService.procoreUserInfo.email)
		// 	.subscribe((result) => {
		// 		// if (response == true) {
		// 		// 	//this.emitRequestCancelled.emit(this.signatureObject);
		// 		// } else {
		// 		// 	// TODO: Show an error?
		// 		// }

		// 		window.open(result, '_blank');

		// 		this.loadingCancelRequest = false;
		// 	});
	}

	continueRequest() {
		this.loading = true;
		// this.adobeService.getAdobeAuthoringAgreementDraft(this.signatureObject.clientSignature.signatureRequestId, this.contextService.procoreContextObject.context.company_id, this.contextService.procoreUserInfo.email)
		// 	.subscribe((result) => {
		// 		// if (response == true) {
		// 		// 	//this.emitRequestCancelled.emit(this.signatureObject);
		// 		// } else {
		// 		// 	// TODO: Show an error?
		// 		// }

		// 		window.open(result, '_blank');

		// 		this.loadingCancelRequest = false;
		// 	});
	}

	markAsCancelled() {
		this.loading = true;
		this.clientService.markAsCancelled(this.contextService.procoreContextObject.context.company_id, this.signatureObject.clientSignature.signatureRequestId, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId, this.contextService.procoreIsSandbox)
			.subscribe(
				(response) => {
					if (response) {
						this.emitRequestCancelled.emit(this.signatureObject);
						this.loading = false;
					} else {
						this.cancelMessage = 'An error occurred while marking the request as cancelled.  Please contact Shake IT for additional support.';
						this.showCancelButton = false;
						this.loading = false;
					}
				},
				(err) => {
					this.cancelMessage = 'An error occurred while marking the request as cancelled.  Please contact Shake IT for additional support.';
					this.showCancelButton = false;
					this.loading = false;
				});
	}
}

